import service from './../service.js';

export default {
    get() {
        return service.get('/module');
    }
}